/**
 * Agent Service - Handles all API interactions related to agents
 */

import { get, post, put, del } from '../utils/apiUtils';

// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/persistence/agents`;
const QUEUE_URL = `/api/v1/persistence/agent_queue`;

/**
 * Get all agents
 * @returns {Promise<Array>} List of agents
 */
export const getAgents = async (filters = {}, sort = {}, query = null) => {
  try {
    const response = await post(`${API_URL}/fetch?${query}`, { filter: filters, sort: sort });
    return response;
  } catch (error) {
    console.error('Error fetching personas:', error);
    throw error;
  }
};

export const fetchQueue = async (filters = {}, sort = {}, query = null) => {
  try {
    const response = await post(`${QUEUE_URL}/fetch?query=${query}`, { filter: filters, sort: sort });
    return response;
  } catch (error) {
    console.error('Error fetching personas:', error);
    throw error;
  }
};

/**
 * Create a new agent
 * @param {Object} agentData - The agent data
 * @returns {Promise<Object>} Created agent
 */
export const createAgent = async (data) => {
  try {
    const response = await post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error('Error creating Agent:', error);
    throw error;
  }
};
/**
 * Update an existing agent
 * @param {string} agentId - The agent ID
 * @param {Object} agentData - The updated agent data
 * @returns {Promise<Object>} Updated agent
 */
export const updateAgent = async (data) => {
  try {
    const response = await put(`${API_URL}`, data);
    return response;
  } catch (error) {
    console.error(`Error updating persona :`, error);
    throw error;
  }
};


/**
 * Delete an agent
 * @param {string} agentId - The agent ID
 * @returns {Promise<void>}
 */
export const deleteAgent = (agentId) => {
  return del(`${API_URL}/${agentId}`);
};

/**
 * Activate an agent
 * @param {string} agentId - The agent ID
 * @returns {Promise<Object>} Updated agent status
 */
export const activateAgent = (agentId) => {
  return post(`${API_URL}/${agentId}/activate`);
};

/**
 * Deactivate an agent
 * @param {string} agentId - The agent ID
 * @returns {Promise<Object>} Updated agent status
 */
export const deactivateAgent = (agentId) => {
  return post(`${API_URL}/${agentId}/deactivate`);
};

/**
 * Get agent metrics
 * @param {string} agentId - The agent ID
 * @returns {Promise<Object>} Agent metrics
 */
export const getAgentMetrics = (agentId) => {
  return get(`${API_URL}/${agentId}/metrics`);
};

/**
 * Get agent tasks
 * @param {string} agentId - The agent ID
 * @returns {Promise<Array>} List of agent tasks
 */
export const getAgentTasks = (agentId) => {
  return get(`${API_URL}/${agentId}/tasks`);
};

/**
 * Get agent tasks
 * @param {string} agentId - The agent ID
 * @returns {Promise<Array>} List of agent tasks
 */
export const getAgentsCount = async () => {
   try {
      const response = await post(`${API_URL}/count`, {});
      return response.count;
    } catch (error) {
      console.error('Error fetching knowledge bases:', error);
      throw error;
    }
} 

export default {
  getAgents,
  fetchQueue,
  createAgent,
  updateAgent,
  deleteAgent,
  activateAgent,
  deactivateAgent,
  getAgentMetrics,
  getAgentTasks
};
